<nav class="navbar navbar-light bg-white mb-4">
  <div class="container-fluid">
    <div class="row w-100 mobile-view-row">
      <div class="col-md-12 col-lg-12 col-xl-8">
        <div class="row">
          <div class="col-xl-12 col-md-12">
            <div class="d-flex justify-content-end">
              <div class="row  py-2">
                <div class="col-md-6 d-flex gap-2">
                  <input pInputText id="search card" [(ngModel)]="searchCard.value" class="w-100"
                    [placeholder]="'searchcard' | translate" />
                  <button class="btn searchBtn" (click)="searchByCard()">
                    <i *ngIf="!isLoadingforCard" class="pi pi-search"></i>
                    <mat-spinner *ngIf="isLoadingforCard" diameter="20"></mat-spinner>
                  </button>
                </div>
                <div class="col-md-6 d-flex gap-2">
                  <input pInputText id="search claim" [(ngModel)]="searchClaim.value"
                    [placeholder]="'searchclaim' | translate" class="w-100" />
                  <button class="btn searchBtn" (click)="getClaimdata()">
                    <i *ngIf="!loading" class="pi pi-search"></i>
                    <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-xl-4 col-lg-12">
        <div class="d-flex justify-content-end align-items-center language-switcher py-2 gap-3">
          <p-dropdown [options]="languages" [(ngModel)]="selectedLanguage" (onChange)="changeLanguage($event.value)"
            optionLabel="name" optionValue="code" class="w-full">
            <ng-template let-lang pTemplate="selectedItem">
              <div class="d-flex align-items-center gap-2">
                <img [src]="getFlag(lang?.code)" class="mr-2" />
                <span [ngStyle]="{'font-family': lang?.code === 'ar' ? 'Noto Kufi Arabic, sans-serif' : 'inherit'}">{{
                  lang?.name }}</span>
              </div>
            </ng-template>
            <ng-template let-lang pTemplate="item">
              <div class="d-flex align-items-center gap-2">
                <img [src]="getFlag(lang?.code)" class="mr-2" />
                <span [ngStyle]="{'font-family': lang?.code === 'ar' ? 'Noto Kufi Arabic, sans-serif' : 'inherit'}">{{
                  lang?.name }}</span>
              </div>
            </ng-template>
          </p-dropdown>
          <button class="btn" matTooltip="Notifications" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight"
            [matBadge]="unreadCount" matBadgeColor="warn" aria-controls="offcanvasRight"
            [disabled]="allNotifications.length < 1">
            <i class="pi pi-bell icons-end"></i>
          </button>
          <button class="btn" (click)="logout()" matTooltip="Logout">
            <i class="pi pi-sign-out icons-end" [ngClass]="{ 'rtl-icon': locale === 'ar' }"></i>
          </button>

        </div>
      </div>
    </div>
  </div>
</nav>


<div class="offcanvas" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel" #offcanvasRight
  [ngClass]="locale === 'ar' ? 'offcanvas-start' : 'offcanvas-end'">

  <div class="offcanvas-header">
    <h5 id="offcanvasRightLabel">Notifications</h5>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body pt-0">
    <ul [class.notifications-animate]="isOffcanvasOpen">
      <li *ngFor="let notification of paginatedNotifications">
        <div class="d-flex justify-content-between align-items-center gap-2 notification-bg p-3 rounded-2 mb-2">
          <div>
            <p class="mb-0 text-muted small">
              {{ notification.notificationCreatedOn | date:'medium' }}
            </p>
            <h5 class="mb-1">{{ notification.notificationFrom }}</h5>
            <p class="mb-0">{{ notification.notificationMessage }}</p>

          </div>
          <div>
            <button mat-icon-button (click)="toggleEnvelope(notification.id)" aria-label="Toggle envelope"
              [disabled]="notification.isRead === 1">
              <mat-icon>
                {{ notification.isRead === 0 || notification.isRead == null ? 'mark_email_unread' : 'mark_email_read' }}
              </mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

    <div class="d-flex justify-content-between mt-3">
      <button class="btn btn-secondary rounded-2 text-white px-4 py-2" (click)="prevPage()"
        [disabled]="currentPage === 1">Next</button>
      <span class="d-flex align-items-center">Page {{currentPage}} / {{totalPages}}</span>
      <button class="btn btn-secondary rounded-2 text-white px-4 py-2" (click)="nextPage()"
        [disabled]="currentPage === totalPages">Prevoius</button>
    </div>
  </div>
</div>